export default async function runValidator(validator, value) {
  const result = await validator.callback(value);
  return {
    valid: typeof result === 'object' ? result.valid : result,
    message: validator.message,
    ...(typeof result === 'object' ? result : {})
  };
}